export const CURRENCY = {
  EUR: "Euro",
  AED: "United Arab Emirates dirham",
};

export const CURRENCY_3_LETTER = {
  EUR: "EUR",
  AED: "AED",
  USD: "USD",
  TRY: "TRY",
  SAR: "SAR",
  GBP: "GBP",
};

export const CURRENCY_SYMBOL = {
  EUR: "€",
  AED: "AED",
  USD: "$",
};

export const COUNTRY = {
  IT: "Italy",
  AE: "United Arab Emirates",
};
export const CONTACT_US_EMAIL = "team@creditit.ai";

export const YES_NO = {
  YES: "yes",
  NO: "no",
};

export const CREDIT_UTILIZATION_RATE_THRESHOLDS = {
  GOOD: 70,
  WATCH: 90,
};

export const PAYMENT_PERFORMANCE_RATE_THRESHOLDS = {
  EXCELLENT: 85,
  MODERATE: 70,
};

export const GENERAL_LAYOUT_CONTENT_CSS = "max-w-5xl mx-auto";
